<template>
  <div>
    <h2 class="mt-4 mb-2">Attachments</h2>
    <div class="row mb-5 mt-2" v-if="$_can('claims.files.store')">
      <div class="col-12 col-sm-12 col-md-2">
        <ClaimFileUpload
          :label="'<u>Browse</u> or drag to upload'"
          :type-id="5"
          :style-class="'rectangle-upload'"
          :model="'claims'"
          :model-id="claim.id"
          ref="refGalleryUpload"
          @update="loadClaim"
        />
      </div>

      <template class="file-div" v-if="claimFiles">
        <div class="col-12 col-sm-12 col-md-2" v-for="file in claimFiles" :key="file.id">
          <div
            :id="file.id"
            style="background-size: cover;background-position:center; position: relative;border-radius: 2px; outline: none;"
            class="rec-upload d-inline-block"
          >
            <div class="file-view-wrapper">
              <div class="img-delete" @click="deleteFile(file.id)"><img src="../../assets/img/gallery-close.svg" /></div>
              <div class="d-flex align-content-start p-4 image-wrapper">
                <div class="mr-2">
                  <span v-if="file.mime === 'image/gif' || file.mime === 'image/png' || file.mime === 'image/jpg' || file.mime === 'image/jpeg'">
                    <i class="fa fa-image" />
                  </span>
                  <span v-if="
                    file.mime === 'application/pdf' ||
                      file.mime === 'text/plain' ||
                      file.mime === 'application/msword' ||
                      file.mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                      file.mime === 'application/vnd.ms-excel' ||
                      file.mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                  >
                    <i class="fa fa-file" />
                  </span>
                  <span v-if="
                    file.mime === 'video/x-msvideo' ||
                      file.mime === 'video/mpeg' ||
                      file.mime === 'video/mp4' ||
                      file.mime === 'video/x-ms-wmv' ||
                      file.mime === 'video/avi' ||
                      file.mime === 'application/x-troff-msvideo' ||
                      file.mime === 'video/msvideo' ||
                      file.mime === 'video/x-mpeg'"
                  >
                    <i class="fa fa-video" />
                  </span>
                  <span v-if="
                    file.mime === 'audio/mpeg' ||
                      file.mime === 'audio/x-ms-wma' ||
                      file.mime === 'audio/mpeg3' ||
                      file.mime === 'audio/x-mpeg-3' ||
                      file.mime === 'audio/mp3'"
                  >
                    <i class="fa fa-file-audio" />
                  </span>
                </div>
                <div class="img-link pointer" @click="viewImg(file.url)">
                  <p>{{ file.name }}</p>
                </div>
              </div>
              <div class="d-flex align-content-start p-4 image-wrapper">
                <p>{{ file.date }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapMutations } from 'vuex';
import ClaimFileUpload from '../ClaimFileUpload';
import Errors from '../../classes/Errors';

export default {
  components: { ClaimFileUpload },
  props: {
    claim: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    claimFiles: [],
    errors: new Errors(),
  }),
  computed: {},
  created() {
    this.getFiles();
  },
  methods: {
    ...mapActions(['getClaims']),
    ...mapMutations(['setClaims']),
    getFiles() {
      axios
        .get(`/claims/${this.claim.id}/files`)
        .then(res => {
          this.claimFiles = res.data.data;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    viewImg(image) {
      window.open(image, '_blank');
    },
    loadClaim() {
      axios
        .get(`claims/${this.$route.params.id}`)
        .then(res => {
          this.setClaims(res.data.data);
          this.getFiles();
          this.$emit('update');
        })
        .then(() => {
          this.$refs.refGalleryUpload.afterQueueComplete();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    deleteFile(id) {
      axios
        .delete(`claims/${this.claim.id}/files/${id}`)
        .then(() => {
          this.getFiles();
          this.$emit('update');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
  },
};
</script>

<style scoped>
.square-upload:first-child {
  border: none;
  margin: 0 auto;
  outline: 1px dashed lightgrey;
}

.file-div {
  position: relative;
  height: 100%;
  width: 100%;
}
.col-12.col-sm-12.col-md-2 {
  max-width: 200px;
  margin-right: 5px;
}

.img-delete {
  position: absolute;
  right: 3px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.image-wrapper {
  padding-left: 10px !important;
  padding-right: 30px !important;
}
.img-link:hover {
  color: #617eb6;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/ClaimAttachments.vue